import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Auth from './../components/Auth';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    domain: state.domain,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
